import type { ColDef } from 'ag-grid-community'
import type { Match } from '../../../../../../api/useSupplierReconciliation/types/match'
import { MatchActionsRenderer } from '../../renderers/MatchActionsRenderer'

export function getActionColumns(): ColDef<Match>[] {
  return [
    // Actions column with search, hold/unhold, and approve functionality
    {
      colId: 'actions',
      headerName: 'ACTIONS',
      flex: 1,
      filter: false,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 8px',
        height: '100%',
      },
      cellRenderer: MatchActionsRenderer,
      suppressSizeToFit: true,
      maxWidth: 150,
      minWidth: 150,
      pinned: 'right',
    },
  ]
}
